import axios from 'axios';

const API = axios.create({ baseURL: 'https://urbanpro.devhousesolution.com/api' });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_access_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
